import TransferIndexPage from "../pages/management/transfer/TransferIndexPage.vue";
import TransferCreatePage from "../pages/management/transfer/TransferCreatePage.vue";
import TransferEditPage from "../pages/management/transfer/TransferEditPage.vue";
import IndexArrivalDeclarationPage from "../pages/management/arrivalDeclarations/IndexArrivalDeclarationPage.vue";
import EditArrivalDeclarationPage from "../pages/management/arrivalDeclarations/EditArrivalDeclarationPage.vue";
import IndexExitDeclarationPage from "../pages/management/exitDeclarations/IndexExitDeclarationPage.vue";
import EditExitDeclarationPage from "../pages/management/exitDeclarations/EditExitDeclarationPage.vue";
import IndexInventoriesPage from "../pages/management/inventories/IndexInventoriesPage.vue";
import CreateInventoryPage from "../pages/management/inventories/CreateInventoryPage.vue";
import EditInventoryPage from "../pages/management/inventories/EditInventoryPage.vue";
import IndexWarehousePage from "../pages/management/warehouses/IndexWarehousePage.vue";
import EditWarehousePage from "../pages/management/warehouses/EditWarehousePage.vue";
import IndexSupplierPage from "../pages/management/suppliers/IndexSupplierPage.vue";
import EditSupplierPage from "../pages/management/suppliers/EditSupplierPage.vue";
import IndexArrivalDeclarationStatusPage from "../pages/management/arrivalDeclarationStatuses/IndexArrivalDeclarationStatusPage.vue";
import CreateArrivalDeclarationStatusPage from "../pages/management/arrivalDeclarationStatuses/CreateArrivalDeclarationStatusPage.vue";
import EditArrivalDeclarationStatusPage from "../pages/management/arrivalDeclarationStatuses/EditArrivalDeclarationStatusPage.vue";
import IndexExitDeclarationStatusPage from "../pages/management/exitDeclarationStatuses/IndexExitDeclarationStatusPage.vue";
import CreateExitDeclarationStatusPage from "../pages/management/exitDeclarationStatuses/CreateExitDeclarationStatusPage.vue";
import EditExitDeclarationStatusPage from "../pages/management/exitDeclarationStatuses/EditExitDeclarationStatusPage.vue";
import IndexInventoryStatusPage from "../pages/management/inventoryStatuses/IndexInventoryStatusPage.vue";
import CreateInventoryStatusPage from "../pages/management/inventoryStatuses/CreateInventoryStatusPage.vue";
import EditInventoryStatusPage from "../pages/management/inventoryStatuses/EditInventoryStatusPage.vue";
import i18n from '../i18n';

const basePath = "/app/projects/:projectUuid/wms";

const managementRoutes = [
    {
        path: `${basePath}/transfers`,
        name: "TransferIndexPage",
        component: TransferIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.TransferIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/transfers/create`,
        name: "TransferCreatePage",
        component: TransferCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.TransferIndexPage"), linkName: "TransferIndexPage" },
                    { name: i18n.global.t("pages.TransferCreatePage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/transfers/:transferUuid/edit`,
        name: "TransferEditPage",
        component: TransferEditPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.TransferIndexPage"), linkName: "TransferIndexPage" },
                    { name: i18n.global.t("pages.TransferEditPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/arrival-declarations`,
        name: "IndexArrivalDeclarationPage",
        component: IndexArrivalDeclarationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexArrivalDeclarationPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/arrival-declarations/:arrivalDeclarationUuid/edit`,
        name: "EditArrivalDeclarationPage",
        component: EditArrivalDeclarationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexArrivalDeclarationPage"), linkName: "IndexArrivalDeclarationPage" },
                    { name: i18n.global.t("pages.EditArrivalDeclarationPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/exit-declarations`,
        name: "IndexExitDeclarationPage",
        component: IndexExitDeclarationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexExitDeclarationPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/exit-declarations/:exitDeclarationUuid/edit`,
        name: "EditExitDeclarationPage",
        component: EditExitDeclarationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexExitDeclarationPage"), linkName: "IndexExitDeclarationPage" },
                    { name: i18n.global.t("pages.EditExitDeclarationPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/inventories`,
        name: "IndexInventoriesPage",
        component: IndexInventoriesPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexInventoriesPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/inventories/create`,
        name: "CreateInventoryPage",
        component: CreateInventoryPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexInventoriesPage"), linkName: "IndexInventoriesPage" },
                    { name: i18n.global.t("pages.CreateInventoryPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/inventories/:inventoryUuid/edit`,
        name: "EditInventoryPage",
        component: EditInventoryPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexInventoriesPage"), linkName: "IndexInventoriesPage" },
                    { name: i18n.global.t("pages.EditInventoryPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/warehouses`,
        name: "IndexWarehousePage",
        component: IndexWarehousePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexWarehousePage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/warehouses/:warehouseUuid/edit`,
        name: "EditWarehousePage",
        component: EditWarehousePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexWarehousePage"), linkName: "IndexWarehousePage" },
                    { name: i18n.global.t("pages.EditWarehousePage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/suppliers`,
        name: "IndexSupplierPage",
        component: IndexSupplierPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexSupplierPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/suppliers/:supplierUuid/edit`,
        name: "EditSupplierPage",
        component: EditSupplierPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexSupplierPage"), linkName: "IndexSupplierPage" },
                    { name: i18n.global.t("pages.EditSupplierPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/arrival-declaration-statuses`,
        name: "IndexArrivalDeclarationStatusPage",
        component: IndexArrivalDeclarationStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexArrivalDeclarationStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/arrival-declaration-statuses/create`,
        name: "CreateArrivalDeclarationStatusPage",
        component: CreateArrivalDeclarationStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexArrivalDeclarationStatusPage"), linkName: "IndexArrivalDeclarationStatusPage" },
                    { name: i18n.global.t("pages.CreateArrivalDeclarationStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/arrival-declaration-statuses/:arrivalDeclarationStatusUuid/edit`,
        name: "EditArrivalDeclarationStatusPage",
        component: EditArrivalDeclarationStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexArrivalDeclarationStatusPage"), linkName: "IndexArrivalDeclarationStatusPage" },
                    { name: i18n.global.t("pages.EditArrivalDeclarationStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/exit-declaration-statuses`,
        name: "IndexExitDeclarationStatusPage",
        component: IndexExitDeclarationStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexExitDeclarationStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/exit-declaration-statuses/create`,
        name: "CreateExitDeclarationStatusPage",
        component: CreateExitDeclarationStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexExitDeclarationStatusPage"), linkName: "IndexExitDeclarationStatusPage" },
                    { name: i18n.global.t("pages.CreateExitDeclarationStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/exit-declaration-statuses/:exitDeclarationStatusUuid/edit`,
        name: "EditExitDeclarationStatusPage",
        component: EditExitDeclarationStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexExitDeclarationStatusPage"), linkName: "IndexExitDeclarationStatusPage" },
                    { name: i18n.global.t("pages.EditExitDeclarationStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/inventory-statuses`,
        name: "IndexInventoryStatusPage",
        component: IndexInventoryStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexInventoryStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/inventory-statuses/create`,
        name: "CreateInventoryStatusPage",
        component: CreateInventoryStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexInventoryStatusPage"), linkName: "IndexInventoryStatusPage" },
                    { name: i18n.global.t("pages.CreateInventoryStatusPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/inventory-statuses/:inventoryStatusUuid/edit`,
        name: "EditInventoryStatusPage",
        component: EditInventoryStatusPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexInventoryStatusPage"), linkName: "IndexInventoryStatusPage" },
                    { name: i18n.global.t("pages.EditInventoryStatusPage") }
                ]
            }
        }
    }
]

export default managementRoutes;